import type { Feature } from '@luna/gatekeeper';

export const expirationTime: Feature = {
    enabled: false,
    _description: 'Displays expiration time label in the debit card header',
};
